var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "rgb(250, 175, 0)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87989 5.42152L8.5 2.20202L10.1201 5.42152C10.2777 5.73477 10.5737 5.96864 10.9341 6.03402L14.4234 6.66701L11.9333 9.35326C11.6926 9.61285 11.5872 9.96538 11.6341 10.3076L12.1366 13.9707L9.01542 12.3616L8.67175 13.0282L9.01542 12.3616C8.69148 12.1946 8.30852 12.1946 7.98458 12.3616L4.86344 13.9707L5.36588 10.3076C5.41282 9.96538 5.30736 9.61285 5.06673 9.35326L2.57663 6.66701L6.06591 6.03402C6.42631 5.96864 6.72225 5.73477 6.87989 5.42152ZM12.2277 14.6349C12.2277 14.6348 12.2276 14.6347 12.2276 14.6346L12.2277 14.6349ZM12.7569 14.2905C12.757 14.2905 12.7572 14.2906 12.7574 14.2907L12.7569 14.2905Z",
    stroke: "rgb(250, 175, 0)",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4e83ee53aea8a08f8f564e86a04133aa.svg";
export { ForwardRef as ReactComponent };